// Shared by world.ts and levels.ts

/** A point [x, y] (cable corners, plug points) */
export type Pt = [number, number];

/** What terms() needs to know about a machine (level objects and ObjData alike) */
export interface TermObj { t: string; x: number; y: number; h?: number; y0?: number }

// Plug points of each machine (the levels also use them to lay out cables)
export function terms(o: TermObj): Pt[] {
  const x = o.x, y = o.y;
  switch (o.t) {
    case 'robot_batt': return [[x - 64, y], [x + 64, y]];
    case 'robot_holder': return [[x - 60, y], [x + 60, y]];
    case 'robot_lamp': return [[x - 24, y + 22], [x + 24, y + 22]];
    case 'robot_gate': { const hy = y - (o.h || 110) / 2 - 22; return [[x - 50, hy], [x + 50, hy]]; }
    case 'robot_belt': return [[x - 24, y + 50], [x + 24, y + 50]];
    case 'robot_lift': { const yb = (o.y0 || y) + 30; return [[x - 44, yb + 22], [x + 44, yb + 22]]; }
    case 'robot_fan': return [[x - 52, y + 58], [x + 52, y + 58]];
    case 'robot_hiccup': return [[x - 78, y - 76], [x + 78, y - 76]];
    case 'robot_switch': return [[x - 38, y - 4], [x + 38, y - 4]];
  }
  return [];
}
